// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--LmYkW","info":"info--Of8HU","block":"block--K90As","label":"label--UNkOe","value":"value--j5e+6"};